import axios from 'axios';
import store from '../store';

//local: https://10.53.99.168:8443
//vm uat: https://tctims.innocare-x.com
//vm prd: https://pctims.innocare-x.com
// cloud(ctims-backend-dev): https://10.55.180.54:7279, https://tctims-backend.innocare-x.com (佈到aws要用後面連結)
// cloud(ctims-backend-prd): https://10.55.180.54:3625, https://pctims-backend.innocare-x.com (佈到aws要用後面連結)


const url = 'https://pctims.innocare-x.com';


// User相關的 api 初始化
const userRequest = axios.create({
  baseURL: url + '/api/auth/',
  timeout: 30000
});

// 搜尋相關的 api 初始化


const searchRequest = axios.create({
   baseURL: url + '/api/test/',
  timeout: 30000
});

// 客戶相關的 api 初始化
const custRequest = axios.create({
  baseURL: url + '/api/cust/',
  timeout: 30000
});

// 人事相關的 api 初始化
const hrRequest = axios.create({
  baseURL:  url + '/api/hr/',
  timeout: 30000
});

// 客訴相關的 api 初始化
const feedbackRequest = axios.create({
  baseURL: url + '/api/feedback/',
  timeout: 30000
});

// 產品與shipping相關
const psRequest = axios.create({
  baseURL: url + '/api/shipping/',
  timeout: 30000
});

// 與安裝相關
const installRequest = axios.create({
  baseURL: url + '/api/install/',
  timeout: 30000
});

// 產品相關的 api 初始化
const productRequest = axios.create({
  baseURL: url + '/api/product/',
  timeout: 30000
});

//首頁相關的 api 初始化
const announcementRequest = axios.create({
  baseURL: url + '/api/announcement/',
  timeout: 30000
});

//CRCNC
const crcnRequest = axios.create({
  baseURL: url + '/api/crcn/',
  timeout: 30000
});

//ADMIN
const adminRequest = axios.create({
  baseURL: url + '/api/admin/',
  timeout: 30000
});

//UTIL
const utilRequest = axios.create({
  baseURL: url + '/api/util/',
  timeout: 30000
});

//report
const reportRequest = axios.create({
  baseURL: url + '/api/report/',
  timeout: 30000
});

//training
const trainingRequest = axios.create({
  baseURL: url + '/api/training/',
  timeout: 30000
});

// 首頁相關的 api
export const apiAnnouncementByRole = data => announcementRequest.post('/getAnnouncementByRole', data);
export const apiFindAllAnnouncementData = data => announcementRequest.post('/findAllAnnouncementData', data);
export const apiSaveAnnouncementData = data => announcementRequest.post('/saveAnnouncementData', data);
export const apiDeleteAnnouncementById = data => announcementRequest.post('/deleteAnnouncementById', data);

// User 相關的 api
export const apiUserLogin = data => userRequest.post('/signin', data);
export const apiUserLogout = data => userRequest.post('/signOut', data);
export const apiUserSignUp = data => userRequest.post('/signup', data);
export const apiModifyPass = data => userRequest.post('/modifyPass', data);
// export const apiSendIncxMail = data => userRequest.post('/sendIncxMail', data);



// 搜尋相關的 api
export const apiMenuSearch = data => searchRequest.get('/menu',data);
export const apiAllSearch = data => searchRequest.get('/all',data);


// 客戶相關的 api
export const apiFindCustList = data => custRequest.post('/findCustListByCondition', data);
export const apiFindCust = data => custRequest.post('/findByCondition', data);
export const apiFindSysValueByCategory = data => custRequest.post('/findSysValueByCategory', data);
export const apiFindSysAttrValueByCategory = data => custRequest.post('/findSysAttrValueByCategory', data);
export const apiFindCustFromSap = data => custRequest.post('/findCustomerFromSapByCondition', data);
export const apiFindCustById = data => custRequest.post('/findById', data);
export const apiFindProductSelected = data => custRequest.post('/findProductSelectedListByCustId', data);
export const apiFindCustIncxWindows = data => custRequest.post('/findCustIncxWindowsByCustId', data);
export const apiFindCustWarranty = data => custRequest.post('/findCustWarrantyByCustId', data);
export const apiFindCustRma = data => custRequest.post('/findCustRmaByCustId', data);
export const apiFindCustWindows = data => custRequest.post('/findCustWindowsByCustId', data);
export const apiSaveCust = data => custRequest.post('/save/cust', data);
export const apiActivateAccount = data => custRequest.post('/activateAccount', data);
export const apiFindProductListByCustId = data => custRequest.post('/findProductListByCustId', data);
export const apiFindPmByCustNo = data => custRequest.post('/findPmByCustNo', data);
export const apiFindCustSapNoByWindowsAccount = data => custRequest.post('/findCustSapNoByWindowsAccount', data);
export const apiFindAllCustList = data => custRequest.post('/findAllCustList', data);

// 客訴相關的 api
export const apiSaveFeedback = data => feedbackRequest.post('/save/feedback', data);
export const apiFindProductSelectedListByUserAttr = data => feedbackRequest.post('/findProductSelectedListByUserAttr', data);
export const apiFindSwfwByVersionTypeAndName = data => feedbackRequest.post('/findSwfwByVersionTypeAndName', data);
export const apiFindSystemNameAndType = data => feedbackRequest.post('/findSystemNameAndType', data);
export const apiFindFailureItemLevel1 = data => feedbackRequest.post('/findFailureItemLevel1', data);
export const apiFindFailureItemLevel2 = data => feedbackRequest.post('/findFailureItemLevel2', data);
export const apiFindFailureItemLevel3 = data => feedbackRequest.post('/findFailureItemLevel3', data);
export const apiFindFeedbackListForCust = data => feedbackRequest.post('/findFeedbackListForCust', data);
export const apiFindFeedbackList = data => feedbackRequest.post('/findFeedbackList', data);
export const apiFindFeedback = data => feedbackRequest.post('/findFeedback', data);
export const apiFindFeedbackProductTypeByFeedbackId = data => feedbackRequest.post('/findFeedbackProductTypeByFeedbackId', data);
export const apiFindFeedbackFailureTypeByFeedbackId = data => feedbackRequest.post('/findFeedbackFailureTypeByFeedbackId', data);
export const apiFindFeedbackCollaborateByFeedbackId = data => feedbackRequest.post('/findFeedbackCollaborateByFeedbackId', data);
export const apiFindFeedbackUdiByFeedbackId = data => feedbackRequest.post('/findFeedbackUdiByFeedbackId', data);
export const apiFindFeedbackCommByFeedbackId = data => feedbackRequest.post('/findFeedbackCommByFeedbackId', data);
export const apiFindFeedbackRmaByFeedbackId = data => feedbackRequest.post('/findFeedbackRmaByFeedbackId', data);
export const apiFindFeedbackFaeProcessByFeedbackId = data => feedbackRequest.post('/findFeedbackFaeProcessByFeedbackId', data);
export const apiSaveFeedbackFaeProcess = data => feedbackRequest.post('/save/feedbackFaeProcess', data);
export const apiSaveFeedbackComm = data => feedbackRequest.post('/save/feedbackComm', data);
export const apiFeedbackStatusClosed = data => feedbackRequest.post('/update/feedbackStatusClosed', data);
export const apiSendFeedbackCollaborateMail = data => feedbackRequest.post('/sendFeedbackCollaborateMail', data);
export const apiGetFeedbackAuth = data => feedbackRequest.post('/getFeedbackAuth', data);
export const apiSendFeedbackRmaMail = data => feedbackRequest.post('/sendFeedbackRmaMail', data);
export const apiFindSnForFeedbackProductType = data => feedbackRequest.post('/findSnForFeedbackProductType', data);
export const apiFindOdmSnForFeedbackProductType = data => feedbackRequest.post('/findOdmSnForFeedbackProductType', data);
export const apiGetFeedbackRmaStrByFeedbackId = data => feedbackRequest.post('/getFeedbackRmaStrByFeedbackId', data);
export const apiFindFeedbackByCondition = data => feedbackRequest.post('/findFeedbackByCondition', data);
export const apiDeleteFeedbackDoc = data => feedbackRequest.post('/deleteFeedbackDoc', data);
export const apiSendApproveFeedback = data => feedbackRequest.post('/sendApproveFeedback', data);
export const apiFindFirmwareVersion = data => feedbackRequest.post('/findFirmwareVersion', data);
export const apiFindNewCsByLoginId = data => feedbackRequest.post('/findNewCsByLoginId', data);
export const apiFindIncxWindowsByDepartment = data => feedbackRequest.post('/findIncxWindowsByDepartment', data);
export const apiFindNewCsMsgByLoginId = data => feedbackRequest.post('/findNewCsMsgByLoginId', data);
export const apiFindCsTodoByLoginId = data => feedbackRequest.post('/findCsTodoByLoginId', data);
export const apiFindRmaHandlingByCondition = data => feedbackRequest.post('/findIncxFaeRmaHandlingByCondition', data);
export const apiFindCustRmaHandlingByCondition = data => feedbackRequest.post('/findCustRmaHandlingByCondition', data);
export const apiFindCustIncxWindowsForFae = data => feedbackRequest.post('/findCustIncxWindowsForFae', data);
export const apiFindCustIncxWindowsForFaeByFeedbackId = data => feedbackRequest.post('/findCustIncxWindowsForFaeByFeedbackId', data);
export const apiFindCustIncxWindowsForFaeByCustSapCode = data => feedbackRequest.post('/findCustIncxWindowsForFaeByCustSapCode', data);


// 人事相關的 api 初始化
export const apiFindHr = data => hrRequest.post('/findEmpByCondition', data);
export const apiFindEmpEmail = data => hrRequest.post('/findEmailByCondition', data);
export const apiFindEmpByAdAccount = data => hrRequest.post('/findEmpByAdAccount', data);
export const apiFindEmpByEmpNo = data => hrRequest.post('/findEmpByEmpNo', data);

//共用相關 api
export const apiGetAttach = data => custRequest.post('/getAttach', data);
export const apiSaveAttach = data => custRequest.post('/saveAttach', data);
export const apiGetAttachById = data => custRequest.post('/getAttachById', data);
export const apiSaveFileAccessLog = data => custRequest.post('/saveFileAccessLog', data);
export const apiDeleteAttachById = data => custRequest.post('/deleteAttachById', data);

// 產品與shipping相關 api
export const apiFindDongleData = data => psRequest.post('/findDongleData', data);
export const apiSaveDongleData = data => psRequest.post('/saveDongleData', data);
export const apiDeleteDongleDataById = data => psRequest.post('/deleteDongleDataById', data);
export const apiFindSdbShippingSnAndCustSnByCustNo = data => psRequest.post('/findSdbShippingSnAndCustSnByCustNo', data);
export const apiFindSdbShippingBySnAndCustNo = data => psRequest.post('/findSdbShippingBySnAndCustNo', data);
export const apiFindShippingAndReceive = data => psRequest.post('/findSdbShippingAndReceive', data);
export const apiUpdShippingReceiveTime = data => psRequest.post('/update/sdbShippingReceiveTime', data);
export const apiFindSw = data => psRequest.post('/findSw', data);
export const apiFindFw = data => psRequest.post('/findFw', data);
export const apiFindPackage = data => psRequest.post('/findPackage', data);
export const apiFindKa = data => psRequest.post('/findKa', data);
export const apiFindDoc = data => psRequest.post('/findDoc', data);
export const apiSaveSwfwAnnounce = data => psRequest.post('/saveSwfwAnnounce', data);
export const apiFindShipping = data => psRequest.post('/findSdbShipping', data);
export const apiUpdShippingFwVersion = data => psRequest.post('/update/sdbshippingFwVersion', data);
export const apiGetShippingListByCustNo = data => psRequest.post('/getShippingListByCustNo', data);
export const apiFindSwfwListByCustIdAndAccount = data => psRequest.post('/findSwfwListByCustIdAndAccount', data);
export const apiFindSwfwImportantListByCustIdAndAccount = data => psRequest.post('/findSwfwImportantListByCustIdAndAccount', data);
export const apiFindDockListByCustIdAndAccount = data => psRequest.post('/findDockListByCustIdAndAccount', data);
export const apiFindDocListByModel = data => psRequest.post('/findDocListByModel', data);
export const apiFindSwfwVersionType = data => psRequest.post('/findSwfwVersionType', data);
export const apiFindSwfwByCondition = data => psRequest.post('/findSwfwByCondition', data);
export const apiSaveSwfw = data => psRequest.post('/saveSwfw', data);
export const apiDeleteSwfwById = data => psRequest.post('/deleteSwfwById', data);
export const apiFindDocType = data => psRequest.post('/findDocType', data);
export const apiFindDocByCondition = data => psRequest.post('/findDocByCondition', data);
export const apiSaveDoc = data => psRequest.post('/saveDoc', data);
export const apiDeleteDocById = data => psRequest.post('/deleteDocById', data);
export const apiFindDocumentListWithoutVersionLang = data => psRequest.post('/findDocumentListWithoutVersionLang', data);


// 與安裝相關
export const apiFindHardwareDrSn = data => installRequest.post('/findHardwareDrSn', data);
export const apiFindSoftwareVersionByName = data => installRequest.post('/findSoftwareVersionByName', data);
export const apiFindSoftwareUpdVersion = data => installRequest.post('/findSoftwareUpdVersion', data);
export const apiFindSoftwareDongleSn = data => installRequest.post('/findSoftwareDongleSn', data);
export const apiSaveInstall = data => installRequest.post('/save/install', data);
export const apiSubmitInstall = data => installRequest.post('/submit/install', data);
export const apiFindSoftwareList = data => installRequest.post('/findSoftwareList', data);
export const apiFindInstalledList = data => installRequest.post('/findInstalledList', data);
export const apiInstallAcceptTime = data => installRequest.post('/update/installAcceptTime', data);
export const apiFindInstall = data => installRequest.post('/findInstall', data);
export const apiRejectInstall = data => installRequest.post('/rejectInstall', data);
export const apiGetSwfwImportStatus = data => installRequest.post('/getSwfwImportStatus', data);

// 產品相關的 api 初始化
export const apiFindProductMapping = data => productRequest.post('/findProductMappingData', data);
export const apiSaveProductMapping = data => productRequest.post('/saveProductMappingData', data);
export const apiDeleteProductMappingById = data => productRequest.post('/deleteProductMappingById', data);
export const apiFindVersionMapping = data => productRequest.post('/findVersionMappingData', data);
export const apiSaveVersionMapping = data => productRequest.post('/saveVersionMappingData', data);
export const apiDeleteVersionMappingById = data => productRequest.post('/deleteVersionMappingById', data);

//CR,CNC相關
export const apiFindTargetList = data => crcnRequest.post('/findTargetList', data);
export const apiFindModelNameList = data => crcnRequest.post('/findModelNameList', data);
export const apiSaveCrDoc = data => crcnRequest.post('/save/crDoc', data);
export const apiSubmitCrDoc = data => crcnRequest.post('/submit/crDoc', data);
export const apiFindCrDocById = data => crcnRequest.post('/findCRById', data);
export const apiFindCRByCondition = data => crcnRequest.post('/findCRByCondition', data);
export const apiSendApproveCRDoc = data => crcnRequest.post('/sendApprove/crDoc', data);
export const apiHasEcrecnAuth = data => crcnRequest.post('/hasEcrecnAuth', data);
export const apiSaveEcrecn = data => crcnRequest.post('/save/ecrecn', data);
export const apiCreateCNC = data => crcnRequest.post('/createCNC', data);
export const apiFindCRByCondition2 = data => crcnRequest.post('/findCRByCondition2', data);
export const apiFindSwFwListByTarget = data => crcnRequest.post('/findSwFwListByTarget', data);
export const apiFindDocNoModelRelListByTarget = data => crcnRequest.post('/findDocNoModelRelListByTarget', data);
export const apiSaveCncDoc = data => crcnRequest.post('/save/cncDoc', data);
export const apiSendApproveCNCDoc = data => crcnRequest.post('/sendApprove/cncDoc', data);
export const apiFindCNCById = data => crcnRequest.post('/findCNCById', data);
export const apiFindCNCByCondition = data => crcnRequest.post('/findCNCByCondition', data);
export const apiHasExecuteCncMailAuth = data => crcnRequest.post('/hasExecuteCncMailAuth', data);
export const apiExecuteCncMail = data => crcnRequest.post('/executeCncMail', data);
export const apiGetCrPersonalTasks = data => crcnRequest.post('/getCrPersonalTasks', data);
export const apiGetCncPersonalTasks = data => crcnRequest.post('/getCncPersonalTasks', data);
export const apiFindEcrEcnTodoByLoginId = data => crcnRequest.post('/findEcrEcnTodoByLoginId', data);



//ADMIN相關
export const apiFindAllSysValueMainData = data => adminRequest.post('/findAllSysValueMainData', data);
export const apiSaveSysValueMainData = data => adminRequest.post('/saveSysValueMainData', data);
export const apiDeleteSysValueMainDataById = data => adminRequest.post('/deleteSysValueMainDataById', data);
export const apiFindAllSysValueDtlData = data => adminRequest.post('/findAllSysValueDtlData', data);
export const apiSaveSysValueDtlData = data => adminRequest.post('/saveSysValueDtlData', data);
export const apiDeleteSysValueDtlDataById = data => adminRequest.post('/deleteSysValueDtlDataById', data);
export const apiFindSwfwName = data => adminRequest.post('/findSwfwName', data);
export const apiFindDocModel = data => adminRequest.post('/findDocModel', data);
export const apiFindDownloadLogByCondition = data => adminRequest.post('/findDownloadLogByCondition', data);


//utilRequest相關
export const apiFindProcessLogListByDocId = data => utilRequest.post('/findProcessLogList', data);

//report
export const apiFeedbackStatByCaseType = data => reportRequest.post('/feedbackStatByCaseType', data);
export const apiGetCustomerCnt = data => reportRequest.post('/getCustomerCnt', data);
export const apiGetCountryCnt = data => reportRequest.post('/getCountryCnt', data);
export const apiGetFeedbackMonthlyCnt = data => reportRequest.post('/getFeedbackMonthlyCnt', data);
export const apiGetTotalFeedbackCnt = data => reportRequest.post('/getTotalFeedbackCnt', data);
export const apiGetRmaCntMonthly = data => reportRequest.post('/getRmaCntMonthly', data);
export const apiGetTotalRmaCnt = data => reportRequest.post('/getTotalRmaCnt', data);
export const apiFeedbackStatByFailureType = data => reportRequest.post('/feedbackStatByFailureType', data);
export const apiFeedbackStatByFailureTypeWithRma = data => reportRequest.post('/feedbackStatByFailureTypeWithRma', data);
export const apiFindModelListByFeedbackSn = data => reportRequest.post('/findModelListByFeedbackSn', data);
export const apiYieldStatByModel = data => reportRequest.post('/yieldStatByModel', data);
export const apiGetShippingCnt = data => reportRequest.post('/getShippingCnt', data);

//training
export const apiFindTrainingByCondition = data => trainingRequest.post('/findByCondition', data);
export const apiTrainingSave = data => trainingRequest.post('/save', data);
export const apiTrainingDeleteById = data => trainingRequest.post('/deleteById', data);
export const apiFaeClosed = data => trainingRequest.post('/faeClosed', data);
export const apiCustConfirm = data => trainingRequest.post('/custConfirm', data);
export const apiCreateTraining = data => trainingRequest.post('/createTraining', data);
export const apiSendTrainingMail= data => trainingRequest.post('/sendTrainingMail', data);


// export const apiFeedbackStatByHardware = data => reportRequest.post('/feedbackStatByHardware', data);
// export const apiFeedbackStatBySoftware = data => reportRequest.post('/feedbackStatBySoftware', data);


searchRequest.interceptors.response.use(success => {
   return success;
}, error => {
  store.dispatch("auth/logout");
  store.push("/login");
  // return error;
})

